export class ReportHistoryService {
  public checkIfPurged(error, ifPurged) {
    if (error.status === 404) {
      // We catch 404s because they're a valid response to requests for purged queries
      const purgedDataset = { columns: [], isPurged: true };
      ifPurged(purgedDataset);
    }
  }

  public fetchQueryRunResult(queryRuns) {
    return Promise.all(
      queryRuns.map((queryRun: any) => {
        if (queryRun.state === 'succeeded' && !queryRun.resultStats) {
          return queryRun
            .result()
            .then((result) => {
              queryRun.resultStats = {
                count: result.count,
                columns: result.columns.length,
              };
              return queryRun;
            })
            .catch((error) => {
              if (error.status === 404) {
                // We swallow 404s because they're a valid response to requests for purged queries
                return queryRun;
              }
            });
        } else {
          return queryRun;
        }
      })
    );
  }
}
